/* BioTech Lifesciences — theme.js */
(function () {
  'use strict';

  var CFG = window.BTL || {};
  var money = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });

  function fmt(paise) {
    if (paise === 0) return 'Free';
    return (CFG.symbol || '\u20B9') + money.format(Math.round(paise / 100));
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart request failed');
      return r.json();
    });
  }

  function getCart() {
    return fetch((CFG.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function paintCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function refreshCount() { getCart().then(paintCount).catch(function () {}); }

  /* ------------------------------------------------------------- nav */

  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-nav-toggle]');
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.getAttribute('data-open') === 'true';
      header.setAttribute('data-open', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      toggle.textContent = open ? 'Menu' : 'Close';
    });
  }

  refreshCount();

  /* ---------------------------------------------------------- cart drawer */

  var drawer = document.querySelector('[data-drawer]');
  var lastFocus = null;

  function drawerRender(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('[data-drawer-lines]');
    var foot = drawer.querySelector('[data-drawer-foot]');

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="drawer__empty"><h3 class="h-3">Nothing here yet</h3>' +
        '<p>Add compounds from the catalogue and they collect here.</p>' +
        '<a class="btn btn--solid btn--block" href="' + (CFG.allUrl || '/collections/all') + '">Browse the catalogue</a></div>';
      foot.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(function (i) {
      return '<div class="supply" data-line="' + i.variant_id + '">' +
        '<div><p class="supply__name">' + esc(i.product_title) + '</p>' +
        (i.variant_title && i.variant_title !== 'Default Title'
          ? '<p class="supply__desc">' + esc(i.variant_title) + '</p>' : '') +
        '<button type="button" class="line__remove" data-remove="' + i.variant_id + '">Remove</button></div>' +
        '<div class="supply__price">' + fmt(i.line_price) + '</div>' +
        '<div class="qty qty--sm">' +
        '<button type="button" data-line-step="-1" aria-label="Decrease quantity">&minus;</button>' +
        '<input type="number" value="' + i.quantity + '" min="0" max="999" inputmode="numeric" aria-label="Quantity of ' + esc(i.product_title) + '">' +
        '<button type="button" data-line-step="1" aria-label="Increase quantity">+</button></div>' +
        '</div>';
    }).join('');

    drawer.querySelector('[data-drawer-total]').textContent = fmt(cart.total_price);
    foot.hidden = false;
  }

  function drawerOpen() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var close = drawer.querySelector('.drawer__close');
    if (close) close.focus();
  }

  function drawerClose() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function drawerSet(variantId, qty) {
    var updates = {};
    updates[variantId] = qty;
    drawer.classList.add('is-busy');
    return post((CFG.cartUrl || '/cart') + '/update.js', { updates: updates })
      .then(function (cart) { drawerRender(cart); paintCount(cart); return cart; })
      .catch(function () {})
      .then(function (c) { drawer.classList.remove('is-busy'); return c; });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); drawerClose(); return; }

      var rm = e.target.closest('[data-remove]');
      if (rm) { e.preventDefault(); drawerSet(rm.getAttribute('data-remove'), 0); return; }

      var step = e.target.closest('[data-line-step]');
      if (step) {
        e.preventDefault();
        var row = step.closest('[data-line]');
        var input = row.querySelector('input');
        var next = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-line-step'), 10);
        drawerSet(row.getAttribute('data-line'), Math.max(0, Math.min(999, next)));
      }
    });

    drawer.addEventListener('change', function (e) {
      var row = e.target.closest('[data-line]');
      if (!row || e.target.type !== 'number') return;
      drawerSet(row.getAttribute('data-line'), Math.max(0, Math.min(999, parseInt(e.target.value, 10) || 0)));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') drawerClose();
    });

    // Header cart link opens the drawer instead of navigating.
    var cartLink = document.querySelector('.header__cart');
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        e.preventDefault();
        getCart().then(function (cart) { drawerRender(cart); drawerOpen(); });
      });
    }
  }


  /* ----------------------------------------------------- add to cart */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    e.preventDefault();

    var id = btn.getAttribute('data-add');
    var sel = btn.getAttribute('data-qty-from');
    var qty = 1;
    if (sel) {
      var f = document.querySelector(sel);
      if (f) qty = Math.max(1, parseInt(f.value, 10) || 1);
    }

    var label = btn.querySelector('[data-add-label]') || btn;
    var original = label.textContent;
    btn.classList.add('is-busy');

    post((CFG.cartUrl || '/cart') + '/add.js', { items: [{ id: Number(id), quantity: qty }] })
      .then(function () {
        if (btn.hasAttribute('data-add-redirect')) {
          window.location.href = CFG.orderUrl || '/pages/order';
          return;
        }
        btn.classList.remove('is-busy');
        label.textContent = 'Added';
        setTimeout(function () { label.textContent = original; }, 1600);
        getCart().then(function (cart) {
          paintCount(cart);
          if (drawer) { drawerRender(cart); drawerOpen(); }
        });
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        label.textContent = 'Unavailable';
        setTimeout(function () { label.textContent = original; }, 2200);
      });
  });

  /* --------------------------------------------------- qty steppers */

  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-step]');
      if (!b) return;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;
      var next = (parseInt(input.value, 10) || min) + parseInt(b.getAttribute('data-step'), 10);
      input.value = Math.max(min, Math.min(999, next));
    });
  });

  /* ------------------------------------------------ product gallery */

  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb || !main) return;
      main.src = thumb.getAttribute('data-full');
      main.srcset = '';
      main.alt = thumb.getAttribute('data-alt') || '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------- cart page */

  var cartRoot = document.querySelector('[data-cart-page]');
  if (cartRoot) {
    var cartSet = function (variantId, qty) {
      var updates = {};
      updates[variantId] = qty;
      cartRoot.classList.add('is-busy');
      post((CFG.cartUrl || '/cart') + '/update.js', { updates: updates })
        .then(function () { window.location.reload(); })
        .catch(function () { cartRoot.classList.remove('is-busy'); });
    };

    cartRoot.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove]');
      if (rm) { e.preventDefault(); cartSet(rm.getAttribute('data-remove'), 0); return; }
      var step = e.target.closest('[data-line-step]');
      if (step) {
        e.preventDefault();
        var line = step.closest('[data-line]');
        var input = line.querySelector('input');
        var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-line-step'), 10);
        cartSet(line.getAttribute('data-line'), Math.max(0, next));
      }
    });

    cartRoot.addEventListener('change', function (e) {
      var line = e.target.closest('[data-line]');
      if (!line) return;
      cartSet(line.getAttribute('data-line'), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  /* ---------------------------------------------------- order page */

  var order = document.querySelector('[data-order]');
  if (!order) return;

  var state = { cart: null, promo: null };

  var elLines = order.querySelector('[data-order-lines]');
  var elTotals = order.querySelector('[data-order-totals]');
  var elSend = order.querySelector('[data-order-send]');
  var elErr = order.querySelector('[data-order-error]');
  var elConfirm = order.querySelector('[data-order-confirm]');
  var promoInput = order.querySelector('[data-promo-input]');
  var promoMsg = order.querySelector('[data-promo-msg]');

  function deliveryFee() {
    var p = order.querySelector('input[name="delivery"]:checked');
    return p ? Number(p.getAttribute('data-fee')) : 0;
  }
  function deliveryName() {
    var p = order.querySelector('input[name="delivery"]:checked');
    return p ? p.getAttribute('data-name') : '';
  }
  function discount(subtotal) {
    if (!state.promo) return 0;
    if (state.promo.kind === 'percent') return Math.round(subtotal * state.promo.value / 100);
    return Math.min(subtotal, state.promo.value * 100);
  }
  function lock() {
    var ready = !!(state.cart && state.cart.items.length) && elConfirm.checked;
    elSend.setAttribute('aria-disabled', ready ? 'false' : 'true');
  }

  function render() {
    var cart = state.cart;
    if (!cart) return;
    paintCount(cart);

    if (!cart.items.length) {
      elLines.innerHTML =
        '<div class="empty"><h3 class="h-3">Nothing in your order yet</h3>' +
        '<p>Add compounds from the catalogue and they will collect here.</p>' +
        '<a class="btn btn--solid" href="' + (CFG.allUrl || '/collections/all') + '">Browse the catalogue</a></div>';
      elTotals.innerHTML = '';
      lock();
      return;
    }

    elLines.innerHTML = cart.items.map(function (i) {
      return '<div class="supply" data-line="' + i.variant_id + '">' +
        '<div><p class="supply__name">' + esc(i.product_title) + '</p>' +
        (i.variant_title && i.variant_title !== 'Default Title'
          ? '<p class="supply__desc">' + esc(i.variant_title) + '</p>' : '') +
        '<button type="button" class="line__remove" data-remove="' + i.variant_id + '">Remove</button></div>' +
        '<div class="qty qty--sm">' +
        '<button type="button" data-line-step="-1" aria-label="Decrease quantity">&minus;</button>' +
        '<input type="number" value="' + i.quantity + '" min="0" max="999" inputmode="numeric" aria-label="Quantity of ' + esc(i.product_title) + '">' +
        '<button type="button" data-line-step="1" aria-label="Increase quantity">+</button></div>' +
        '<div class="supply__price">' + fmt(i.line_price) + '</div></div>';
    }).join('');

    var subtotal = cart.total_price;
    var disc = discount(subtotal);
    var fee = deliveryFee();
    var grand = subtotal - disc + fee;

    var rows = '<div class="totals__row"><span>Subtotal</span><b>' + fmt(subtotal) + '</b></div>';
    if (disc > 0) rows += '<div class="totals__row totals__row--save"><span>Promo ' + esc(state.promo.code) + '</span><b>&minus;' + fmt(disc) + '</b></div>';
    rows += '<div class="totals__row"><span>Delivery' + (deliveryName() ? ' (' + esc(deliveryName()) + ')' : '') + '</span><b>' + fmt(fee) + '</b></div>';
    rows += '<div class="totals__row totals__row--grand"><span>Total</span><b>' + fmt(grand) + '</b></div>';
    elTotals.innerHTML = rows;

    lock();
  }

  function syncSupplies(cart) {
    order.querySelectorAll('[data-supply]').forEach(function (row) {
      var id = Number(row.getAttribute('data-supply'));
      var found = cart.items.filter(function (i) { return i.variant_id === id; })[0];
      var input = row.querySelector('input');
      if (input) input.value = found ? found.quantity : 0;
    });
  }

  function update(variantId, qty) {
    var updates = {};
    updates[variantId] = qty;
    order.querySelectorAll('[data-order-lines], [data-supplies]').forEach(function (n) { n.classList.add('is-busy'); });
    post((CFG.cartUrl || '/cart') + '/update.js', { updates: updates })
      .then(function (cart) { state.cart = cart; syncSupplies(cart); render(); })
      .catch(function () {})
      .then(function () {
        order.querySelectorAll('[data-order-lines], [data-supplies]').forEach(function (n) { n.classList.remove('is-busy'); });
      });
  }

  order.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); update(rm.getAttribute('data-remove'), 0); return; }
    var step = e.target.closest('[data-line-step]');
    if (step) {
      e.preventDefault();
      var row = step.closest('[data-line]') || step.closest('[data-supply]');
      if (!row) return;
      var input = row.querySelector('input');
      var id = row.getAttribute('data-line') || row.getAttribute('data-supply');
      var next = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-line-step'), 10);
      update(id, Math.max(0, Math.min(999, next)));
    }
  });

  order.addEventListener('change', function (e) {
    if (e.target.name === 'delivery') { render(); return; }
    if (e.target === elConfirm) { lock(); return; }
    var row = e.target.closest('[data-line], [data-supply]');
    if (!row || e.target.type !== 'number') return;
    var id = row.getAttribute('data-line') || row.getAttribute('data-supply');
    update(id, Math.max(0, Math.min(999, parseInt(e.target.value, 10) || 0)));
  });

  var promoBtn = order.querySelector('[data-promo-apply]');
  if (promoBtn) {
    promoBtn.addEventListener('click', function () {
      var code = (promoInput.value || '').trim().toUpperCase();
      if (!code) { setPromo(null, 'Enter a code first.', 'err'); return; }
      var match = (CFG.promos || []).filter(function (p) { return p.code === code; })[0];
      if (!match) { setPromo(null, 'That code is not recognised.', 'err'); return; }
      setPromo(match, 'Code ' + code + ' applied.', 'ok');
    });
  }

  function setPromo(promo, msg, s) {
    state.promo = promo;
    if (promoMsg) { promoMsg.textContent = msg; promoMsg.setAttribute('data-state', s); }
    render();
  }

  var fields = ['name', 'email', 'phone', 'address'];

  function validate() {
    var ok = true;
    fields.forEach(function (f) {
      var el = order.querySelector('[name="' + f + '"]');
      if (!el) return;
      var bad = !el.value.trim();
      if (f === 'email' && !bad) bad = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim());
      if (f === 'phone' && !bad) bad = el.value.replace(/\D/g, '').length < 8;
      el.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (bad && ok) el.focus();
      if (bad) ok = false;
    });
    return ok;
  }

  elSend.addEventListener('click', function (e) {
    e.preventDefault();
    if (elSend.getAttribute('aria-disabled') === 'true') return;
    if (!validate()) {
      elErr.textContent = 'Fill in the highlighted fields before sending.';
      elErr.hidden = false;
      return;
    }
    elErr.hidden = true;

    var cart = state.cart;
    var subtotal = cart.total_price;
    var disc = discount(subtotal);
    var fee = deliveryFee();
    var grand = subtotal - disc + fee;
    var v = function (n) {
      var el = order.querySelector('[name="' + n + '"]');
      return el ? el.value.trim() : '';
    };

    var L = [];
    L.push(CFG.greeting || 'Hi — I would like to place an order.');
    L.push('');
    L.push('--- ORDER ---');
    cart.items.forEach(function (i) {
      L.push(i.quantity + ' \u00D7 ' + i.product_title + '  ' + fmt(i.line_price));
    });
    L.push('');
    L.push('Subtotal: ' + fmt(subtotal));
    if (disc > 0) L.push('Promo ' + state.promo.code + ': -' + fmt(disc));
    L.push('Delivery (' + deliveryName() + '): ' + fmt(fee));
    L.push('Total: ' + fmt(grand));
    L.push('');
    L.push('--- SHIP TO ---');
    L.push('Name: ' + v('name'));
    L.push('Email: ' + v('email'));
    L.push('Phone: ' + v('phone'));
    L.push('Address: ' + v('address').replace(/\s*\n\s*/g, ', '));
    if (v('notes')) { L.push(''); L.push('Notes: ' + v('notes')); }
    L.push('');
    L.push('Confirmed: 18 or older, purchasing for laboratory research use only.');

    window.open('https://wa.me/' + (CFG.number || '') + '?text=' + encodeURIComponent(L.join('\n')), '_blank', 'noopener');
  });

  function autoAdd(cart) {
    var row = order.querySelector('[data-supply][data-autoadd]');
    if (!row) return Promise.resolve(cart);

    var id = Number(row.getAttribute('data-supply'));
    var inCart = cart.items.some(function (i) { return i.variant_id === id; });
    var declined = false;
    try { declined = sessionStorage.getItem('btl-autoadd-' + id) === '1'; } catch (e) {}
    if (inCart || declined) return Promise.resolve(cart);

    try { sessionStorage.setItem('btl-autoadd-' + id, '1'); } catch (e) {}

    return post((CFG.cartUrl || '/cart') + '/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(getCart)
      .catch(function () { return cart; });
  }

  getCart()
    .then(autoAdd)
    .then(function (cart) { state.cart = cart; syncSupplies(cart); render(); });
})();
